/* global YT */

import { screenCategory, debounce } from '../library';
import { RESIZE_DEBOUNCE } from "../constants";

export default class RobroyVideo {

  constructor(id) {
    this.video = document.getElementById('main-video');
    this.videoId = id;

    if (!this.video) {
      return;
    }
    this.player = null;
    this.playButton = document.querySelector('.thumbnail-container');

    if (this.videoId && this.playButton) {
      this.setupVideo();
    }

    this.toggle = document.querySelector('.video-summary-toggle');
    this.summary = document.querySelector('.node-robroy-video.node-view-mode-full .body');
    if (this.summary) {
      this.setupToggleText();
    }

    this.preparePlayer = this.preparePlayer.bind(this);
  }

  onPlayerReady(e) {

    console.log('onPlayerready')

    this.playButton.style.display = "block";

    this.playButton.addEventListener('click', () => {
     this.playButton.style.display = "none";

     setTimeout(() => {
       this.player.playVideo();
     }, 100);
   })
  }

  onPlayerStateChange(event) {
    console.log('onPlayerStateChange', event.data);
    switch (event.data) {
      case -1:
        break;

      case 1:
        break;

      case 2:
        break;

      case 3:
        break;

      default:
        break;
    }
  };

  initYoutubeScript() {

    console.log('init Youtube');

    var tag = document.createElement('script');
    tag.id = 'iframe-demo';
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  initToggle() {

    console.log('initToggle() callback');

    if (screenCategory() !== 'mobile' && this.summary.clientHeight > 90) {
      this.summary.classList.add('init-toggle');
      this.toggle.addEventListener('click', function (e) {
        e.preventDefault();
        this.summary.classList.toggle('opened');
      })
    }
  }

  setupToggleText() {
    console.log('setupToggleText');

    window.addEventListener('resize', debounce(this.initToggle, RESIZE_DEBOUNCE) );
    this.initToggle();
  }

  preparePlayer() {
    this.player = new YT.Player('main-video', {
      videoId: this.videoId,
      width: '1920',
      height: '1080',
      rel: 0,
      color: '#be2c37',
      events: {
        // call this function when player is ready to use
        'onReady': this.onPlayerReady.bind(this),
        'onStateChange': this.onPlayerStateChange.bind(this),
      }
    });
  }

  setupVideo() {
    // create the global player from the specific iframe (#video)

    console.log('setupVideo()');

    this.initYoutubeScript();

    // TODO: putting onYouTubeIframeAPIReady here is not consistent. Sometime it is not work
    // window.onYouTubeIframeAPIReady = this.preparePlayer;
  }
}
